module.exports = __webpack_public_path__ + "static/media/CreditCardBanescoLogo.8e57d7f3.svg";